<template lang="pug">
section
  v-toolbar(flat color='white')
    h2(class='title') Действующие роли
    v-spacer
    v-btn(@click='dialog = true' color='primary' depressed) Добавить
  v-divider
  v-data-table(
    :loading='isLoading'
    :headers='headers'
    :items='list'
    :total-items='total'
    :pagination.sync='pagination'
    :rows-per-page-items='$config.rowsPerPageItems'
  )
    template(slot='items' slot-scope='props')
      td {{ props.item.id }}
      td {{ props.item.role_name }}
      td {{ props.item.sites }}
      td {{ props.item.agreement_required ? (props.item.agreed_at ? props.item.agreed_at :'НЕ ПОЛУЧЕНО')  : 'Не требуется' }}
      td {{ props.item.start_time }}
      td {{ props.item.finish_time }}
      td(class='text-xs-right')
        v-btn(@click.stop='onRemove(props.item.id)' icon)
          v-icon(small) delete_outline
  v-flex(xs12)
    s-manager-mini-card(
      :manager='manager'
      @link='openLinkManagerDialog'
      @unlink='onUnlinkManager'
    )
  //- Диалог выбора роли
  v-dialog(scrollable v-model='dialog' max-width='400px' persistent lazy)
    v-card(class='combo-card')
      v-toolbar(flat color='white' prominent)
        v-toolbar-title Добавление роли
      v-container(grid-list-xl)
        v-layout(wrap)
          v-flex(xs12)
            v-select(
              :items='roles'
              label='Роль'
              item-value='role_code'
              item-text='role_name'
              v-model='item.role_code'
            )
          v-flex(xs12)
            s-date-picker(
              :validator='errors'
              v-model='item.start_time'
              name='date_start'
              label='Дата начала действия'
            )
          v-flex(xs12)
            s-date-picker(
              :min='minDate'
              :validator='errors'
              v-model='item.finish_time'
              name='date_finish'
              label='Дата окончания действия'
            )
          v-flex(xs12 v-if='item.role_code === userRoles.ContentPromo')
            s-promo-sites-picker(
              :validator='errors'
              v-model='promo'
              multiple
              label='Для промосайтов'
              :return-object='false'
            )
      v-card-actions
        v-spacer
        v-btn(@click.native='dialog=false' color='default' flat) Отмена
        v-btn(
          @click.native='addUserRole'
          :loading='isLoading'
          color='primary'
          flat
        ) Сохранить
  s-link-managers(
    :dialog='managersDialog'
    @select='onSelectManager'
    @close='managersDialog = false'
  )
</template>

<script>
import http from '@/http'
import { userRoles } from '@/enums/user-roles'
import { mapMutations, mapActions, mapState } from 'vuex'
export default {
  props: ['user'],

  data: () => ({
    managersDialog: false,
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название роли',
        align: 'left',
        value: 'role_name',
        width: '33%',
        sortable: false
      },
      {
        text: 'Роль для сайтов',
        align: 'left',
        value: 'sites',
        width: '0%',
        sortable: false
      },
      {
        text: 'Согласие получено',
        align: 'left',
        value: 'agreed_at',
        width: '0%',
        sortable: false
      },
      {
        text: 'Дата начала действия',
        align: 'left',
        value: 'start_time',
        width: '33%',
        sortable: false
      },
      {
        text: 'Дата окончания действия',
        align: 'left',
        value: 'finish_time',
        width: '33%',
        sortable: false
      },
      {
        text: 'Действия',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    pagination: {},
    isLoading: false,
    total: 0,
    list: [],
    dialog: false,
    roles: [],
    item: {
      sites: null
    },
    promo: [],
    userRoles
  }),

  created() {
    this.fetchRolesList()
  },

  beforeDestroy() {
    this.setManager(null)
  },

  methods: {
    async onSelectManager(manager) {
      this.managersDialog = false

      try {
        await this.linkManager({
          manager_id: manager.id,
          user_id: this.user.id
        })
      } catch (e) {
        this.$root.showSnack('Не удалось привязать менеджера')
      }
      this.fetchUserRoles() 
      this.setManager(manager)
      this.$root.setManager(manager)
    },
    async onUnlinkManager() {
      if (await this.$confirm('Вы уверены')) {
        try {
          await this.unlinkManager({
            manager_id: this.manager.id,
            user_id: this.user.id
          })
        } catch (e) {
          this.$root.showSnack('Не удалось отвязать менеджера')
        }
        this.fetchUserRoles()
        this.setManager(null)
        this.$root.setManager(null)
      }
    },
    openLinkManagerDialog() {
      this.managersDialog = true
    },    
    async fetchUserRoles() {
      if (!this.user.id) return

      this.isLoading = false

      try {
        let { data } = await http.get(`/admin/users/${this.user.id}/roles`, {
          params: {
            page: this.pagination.page
          }
        })
        this.total = data.total
        this.list = data.data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список ролей')
      }

      this.isLoading = false
    },

    async onRemove(id) {
      if (await this.$confirm('Удалить роль пользователя')) {
        try {
          await http.delete(`/admin/users/${this.user.id}/roles/${id}`)
          this.fetchUserRoles()
          this.$emit('remove')
        } catch (e) {
          this.$root.showSnack('Ошибка удаления роли пользователя')
        }
      }
    },

    async addUserRole() {
      try {
        await http.post(`/admin/users/${this.user.id}/roles`, this.item)
        this.fetchUserRoles()
      } catch (e) {
        this.$root.showSnack('Ошибка добавления роли')
      }

      this.dialog = false
    },

    async fetchRolesList() {
      try {
        let { data } = await http.post(`/admin/users/roleinfo`)
        this.roles = data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки справочника ролей')
      }

      this.dialog = false
    },

    formatDate(date) {
      let month = `${date.getMonth() + 1}`
      let day = `${date.getDate() + 1}`
      let year = date.getFullYear()

      if (month.length < 2) month = `0${month}`
      if (day.length < 2) day = `0${day}`

      return [year, month, day].join('-')
    },

    ...mapActions('admin/users', [
      'linkManager',
      'unlinkManager'
    ]),
    ...mapMutations('admin/users', ['setManager'])
  },

  watch: {
    pagination: {
      deep: true,
      handler: 'fetchUserRoles'
    },

    user(data) {
      if (data.id) {
        this.fetchUserRoles()
        this.item = data
      }
    },

    promo(val) {
      this.item.sites = val.join(',')
    }
  },

  computed: {
    minDate() {
      return this.formatDate(new Date())
    },
    ...mapState('admin/users', ['manager'])
  }
}
</script>
